import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { StatusPillType } from './status-pill-type.enum';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lib-general-status-pill',
  imports: [MatIcon],
  templateUrl: './general-status-pill.component.html',
  styleUrl: './general-status-pill.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralStatusPillComponent {
  type = input.required<StatusPillType>();
  readonly error = input<boolean>(false);
  protected readonly StatusPillType = StatusPillType;
}
